<!--
  The mentor version of AiToolsPicture: the mentor asks for the prep of the
  next call, the tool reads it and the earlier calls with the same mentee.
  It shows an example and does nothing.
-->
<template>
  <div
    class="rounded-2xl bg-neutral-50 px-4 py-5 sm:px-6 sm:py-6"
    aria-hidden="true"
  >
    <div
      class="mx-auto max-w-[330px] overflow-hidden rounded-2xl bg-neutral-900 text-left shadow-[0_14px_34px_rgba(20,31,47,0.16)]"
    >
      <div class="flex items-center gap-1.5 bg-neutral-800 px-3 py-2">
        <span class="size-2 rounded-full bg-neutral-600" />
        <span class="size-2 rounded-full bg-neutral-600" />
        <span class="size-2 rounded-full bg-neutral-600" />
        <span class="ml-2 text-[11px] text-neutral-400">Claude Code</span>
      </div>
      <div class="space-y-2 p-4 font-mono text-[11px] leading-relaxed">
        <div class="text-white">&gt; Prep my next call</div>
        <div class="text-neutral-400">growthmentor · get_call_prep</div>
        <div class="text-neutral-200">
          Marta Kowal · Thu 10:00 · pricing for a B2B SaaS
        </div>
        <div class="text-secondary-300">
          2 earlier calls with you · 5 questions ready
        </div>
      </div>
    </div>
  </div>
</template>
